export const addTabInfoToProjects = (projects) => projects.map((project) => ({
  ...project,
  tabInfo: {
    ...project.jsonBody,
    userId: project.userId,
  },
}));
